import styled from '@emotion/styled'
import {
  InfoMediumMaxi600Style,
  InfoXXXLarge600Style,
  InfoMedium500Style,
} from '../../../../../../styles/Text.styles'

export const Container = styled.div`
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  padding-top: 1rem;
`

// Styles for the scenario numbers section (previously BlackScenarioNumbers)
export const NumbersContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  padding-top: 3rem;
  width: 100%;

  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 2rem;
  height: 32rem;
  box-sizing: border-box;
`

export const TrippleWrapper = styled.div`
  flex: 0 0 5rem;
  max-width: 10rem;
  min-width: min-content;
`

// Styles for the tripple component (previously BlackTripple)
export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`

export const TopText = styled.div`
  ${InfoMediumMaxi600Style}
  font-family: 'Noto Sans', sans-serif;
  line-height: 0.6;
`

export const MiddleText = styled.div`
  ${InfoXXXLarge600Style}
  font-family: 'Noto Sans', sans-serif;
  line-height: 1.2;
`

export const BottomText = styled.div`
  ${InfoMedium500Style}
  font-family: 'Noto Sans', sans-serif;
  line-height: 1.2;
`
